var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F0F",
    d: "M7.583 13H9.75v2.167H7.583V13zM7.583 17.333H9.75V19.5H7.583v-2.167zM14.083 13h-2.166v2.167h2.166V13zM11.917 17.333h2.166V19.5h-2.166v-2.167zM18.417 13H16.25v2.167h2.167V13zM16.25 17.333h2.167V19.5H16.25v-2.167z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F0F",
    fillRule: "evenodd",
    d: "M20.583 23.833H5.417c-1.195 0-2.167-.971-2.167-2.166V6.5c0-1.195.972-2.167 2.167-2.167h2.166V2.167H9.75v2.166h6.5V2.167h2.167v2.166h2.166c1.195 0 2.167.972 2.167 2.167v15.167c0 1.195-.972 2.166-2.167 2.166zm0-15.166V6.5H5.417v2.167h15.167zm0 2.166l.001 10.834H5.417V10.833h15.167z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.72fc09274c003e9a969277788459f088.svg";
export { ForwardRef as ReactComponent };